import { PlayerService } from "./PlayerService";

type DragonHeadOpenResponse = {
    text: string[];
};
export type CharacterSheets = {
    item1: string;
    item2: string;
    item3: string;
};

export class DragonHeadService {
    private readonly _playerService: PlayerService = new PlayerService();
    public async openMouth(item1: string, item2: string, item3: string): Promise<DragonHeadOpenResponse> {
        const characterSheetsObject: CharacterSheets = {
            item1: item1,
            item2: item2,
            item3: item3,

        };
        const response: Response = await fetch(`${VITE_API_URL}game/dragonhead/open/${JSON.stringify(characterSheetsObject)}`, {
            headers: {
                "X-PlayerSessionId": this._playerService.getPlayerSessionId(),
            },
        });
        console.log(response);
        const data: DragonHeadOpenResponse = await response.json() as DragonHeadOpenResponse;
        return data;
    }
}
